import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/blogdetail.css";

function BlogDetail(){
    return(
        <>
         <section className="inner-page section-themebg">
              <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h3>Blog Detail Page Title</h3>
                    </div>
                </div>
              </div>
         </section>



         <div className="blog-single gray-bg">
        <div className="container">
            <div className="row align-items-start">
                <div className="col-lg-8 m-15px-tb">
                    <article className="article">
                        <div className="article-img">
                            <img src="https://www.bootdey.com/image/800x350/87CEFA/000000" title="" alt="" />
                        </div>
                        <div className="article-title">
                            <h6><Link to="#">Lifestyle</Link></h6>
                            <h2>They Now Bade Farewell To The Kind But Unseen People</h2>
                            <div className="media">
                                <div className="avatar">
                                    <img src="https://bootdey.com/img/Content/avatar/avatar1.png" title="" alt="" />
                                </div>
                                <div className="media-body">
                                    <label>Rachel Roth</label>
                                    <span>26 FEB 2020</span>
                                </div>
                            </div>
                        </div>
                        <div className="article-content">
                            <p>Aenean eleifend ante maecenas pulvinar montes lorem et pede dis dolor pretium donec dictum. Vici consequat justo enim. Venenatis eget adipiscing luctus lorem. Adipiscing veni amet luctus enim sem libero tellus viverra venenatis aliquam. Commodo natoque quam pulvinar elit.</p>
                            <p>Eget aenean tellus venenatis. Donec odio tempus. Felis arcu pretium metus nullam quam aenean sociis quis sem neque vici libero. Venenatis nullam fringilla pretium magnis aliquam nunc vulputate integer augue ultricies cras. Eget viverra feugiat cras ut. Sit natoque montes tempus ligula eget vitae pede rhoncus maecenas consectetuer commodo condimentum aenean.</p>
                            <h4>What are my payment options?</h4>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <blockquote>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                                <p className="blockquote-footer">Someone famous in <cite title="Source Title">Dick Grayson</cite></p>
                            </blockquote>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                        </div>
                        <div className="nav tag-cloud">
                            <Link to="#">Design</Link>
                            <Link to="#">Development</Link>
                            <Link to="#">Travel</Link>
                            <Link to="#">Web Design</Link>
                            <Link to="#">Marketing</Link>
                            <Link to="#">Research</Link>
                            <Link to="#">Managment</Link>
                        </div>
                    </article>
                    {/* <div className="contact-form article-comment">
                        <h4>Leave a Reply</h4>
                        <form id="contact-form">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <input name="Name" id="name" placeholder="Name *" className="form-control" type="text" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <input name="Email" id="email" placeholder="Email *" className="form-control" type="email" />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <textarea name="message" id="message" placeholder="Your message *" rows="4" className="form-control"></textarea>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="send">
                                        <button className="px-btn theme"><span>Submit</span> <i className="arrow"></i></button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div> */}
                </div>
                <div className="col-lg-4 m-15px-tb blog-aside">
                     
                    <div className="widget widget-author">
                        <div className="widget-title">
                            <h3>Author</h3>
                        </div>
                        <div className="widget-body">
                            <div className="media align-items-center">
                                <div className="avatar">
                                    <img src="https://bootdey.com/img/Content/avatar/avatar6.png" title="" alt="" />
                                </div>
                                <div className="media-body">
                                    <h6>Hello, I'm<br /> Rachel Roth</h6>
                                </div>
                            </div>
                            <p>I design and develop services for customers of all sizes, specializing in creating stylish, modern websites, web services and online stores</p>
                        </div>
                    </div>
                    
                     
                   
                    <div className="widget widget-latest-post">
                        <div className="widget-title">
                            <h3>Latest Post</h3>
                        </div>
                        <div className="widget-body">
                            <div className="latest-post-aside media">
                                <div className="lpa-left media-body">
                                    <div className="lpa-title">
                                        <h5><Link to="#">Prevent 75% of visitors from google analytics</Link></h5>
                                    </div>
                                    <div className="lpa-meta">
                                        <Link className="name" to="#">
                                            Rachel Roth
                                        </Link>
                                        <Link className="date" to="#">
                                            26 FEB 2020
                                        </Link>
                                    </div>
                                </div>
                                <div className="lpa-right">
                                    <Link to="#">
                                        <img src="https://www.bootdey.com/image/400x200/FFB6C1/000000" title="" alt="" />
                                    </Link>
                                </div>
                            </div>
                            <div className="latest-post-aside media">
                                <div className="lpa-left media-body">
                                    <div className="lpa-title">
                                        <h5><Link to="#">Prevent 75% of visitors from google analytics</Link></h5>
                                    </div>
                                    <div className="lpa-meta">
                                        <Link className="name" to="#">
                                            Rachel Roth
                                        </Link>
                                        <Link className="date" to="#">
                                            26 FEB 2020
                                        </Link>
                                    </div>
                                </div>
                                <div className="lpa-right">
                                    <Link to="#">
                                        <img src="https://www.bootdey.com/image/400x200/FFB6C1/000000" title="" alt="" />
                                    </Link>
                                </div>
                            </div>
                            <div className="latest-post-aside media">
                                <div className="lpa-left media-body">
                                    <div className="lpa-title">
                                        <h5><Link to="#">Prevent 75% of visitors from google analytics</Link></h5>
                                    </div>
                                    <div className="lpa-meta">
                                        <Link className="name" to="#">
                                            Rachel Roth
                                        </Link>
                                        <Link className="date" to="#">
                                            26 FEB 2020
                                        </Link>
                                    </div>
                                </div>
                                <div className="lpa-right">
                                    <Link to="#">
                                        <img src="https://www.bootdey.com/image/400x200/FFB6C1/000000" title="" alt="" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                  
                    <div className="widget widget-tags">
                        <div className="widget-title">
                            <h3>Latest Tags</h3>
                        </div>
                        <div className="widget-body">
                            <div className="nav tag-cloud">
                                <Link to="#">Design</Link>
                                <Link to="#">Development</Link>
                                <Link to="#">Travel</Link>
                                <Link to="#">Web Design</Link>
                                <Link to="#">Marketing</Link>
                                <Link to="#">Research</Link>
                                <Link to="#">Managment</Link>
                            </div>
                        </div>
                    </div>
                     
                </div>
            </div>
        </div>
    </div>  
        </>
    );

}
export default BlogDetail;